<template>
  <div>
    <ejs-dialog ref="dialog" v-bind="dialogProps" @close="onDialogClose">
      <div
        class="typePos"
        :style="{
          minWidth: `${dialogProps.width}px`,
          minHeight: `${dialogProps.height - 66}px`,
        }"
      >
        <div class="typePos-wrapper-main">
          <ejs-grid-wrapper
            ref="grid"
            v-bind="initGrid"
            @queryCellInfo="onGridQueryCellInfo"
            @cellEdit="onGridCellEdit"

          />
        </div>
        <div class="typePos-wrapper-footer">
            <ul class="typePos-header">
                <li class="typePos-check">
                    <ul class="ui-check">
                        <li><label><input type="checkbox" v-model="isComfrimPrint"/><div class="i-item">확인/출력 항목 보이기</div></label></li>
                    </ul>
                </li>
            </ul>
          <ul class="typePos-button">

            <li class="typePos-check">
              <ul class="ui-check">
                <li><label><input type="checkbox" v-model="isBillPrinter"/><div class="i-item">POS프린터</div></label></li>
              </ul>
            </li>
              <li class="typePos-check">
                  <ul class="ui-check">
                      <li><label><input type="checkbox" v-model="isKitchenPrintner"/><div class="i-item">주방프린터</div></label></li>
                  </ul>
              </li>
              <li>
                  <!-- 비활성(Attribute) : disabled -->
                  <erp-button
                          button-div="GET"
                          class="ui-button i-typePrimary i-iconConfirm"
                          :use-syncfusion-component-style="false"
                          @click.native="onClickComfrim"
                  >
                      <div class="i-item">확인 처리</div>
                  </erp-button>
              </li>
            <li>
              <!-- 비활성(Attribute) : disabled -->
              <erp-button
                button-div="GET"
                class="ui-button i-typePrimary i-iconConfirm"
                :use-syncfusion-component-style="false"
                @click.native="onClickPrint"
              >
                <div class="i-item">출력/재출력</div>
              </erp-button>
            </li>
            <li>
              <!-- 비활성(Attribute) : disabled -->
              <erp-button
                button-div="CLOSE"
                class="ui-button i-iconClose"
                :use-syncfusion-component-style="false"
                @click.native="onCloseClick"
              >
                <div class="i-item">닫기</div>
              </erp-button>
            </li>
          </ul>
        </div>
      </div>
    </ejs-dialog>
    <!-- 팝업 -->
  </div>
</template>

<style scoped>
.typePos {display: flex; flex-direction: column; box-sizing: border-box; width: calc(100% + 36px); height: calc(100% + 18px); margin: 0 -18px -18px -18px; border-top: 1px solid #bebebe;}

.typePos .typePos-wrapper-caption {padding: 10px; border-bottom: 1px solid #bebebe;}
.typePos .typePos-wrapper-caption::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-filed,
.typePos .typePos-wrapper-caption .typePos-lookup {float: left;}
.typePos .typePos-wrapper-caption .typePos-filed {padding: 0 3px;}
.typePos .typePos-wrapper-caption .typePos-lookup {padding: 0 10px;}
.typePos .typePos-wrapper-caption .typePos-filed::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-title,
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content {float: left; padding: 0 7px; color: #666; font-size: 13px; font-family: 'NanumSquare-Regular'; line-height: 19px;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-title {padding-top: 10px; padding-bottom: 11px; color: #222; font-family: 'NanumSquare-Bold';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item {float: left; padding-left: 10px;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item:first-child {padding-left: 0;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-title,
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-content {float: left; padding-top: 10px; padding-bottom: 11px;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-title {padding-right: 4px; color: #222; font-family: 'NanumSquare-Bold';}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-content strong {color: #18b3c9; font-weight: normal;}
.typePos .typePos-wrapper-caption .typePos-filed .typePos-filed-content .typePos-item .typePos-content em {color: #df2929; font-style: normal;}
.typePos .typePos-wrapper-caption .typePos-lookup >>> .ui-button .i-item::before {background-position-x: calc(-20px * 7);}
.typePos .typePos-wrapper-caption .typePos-header {float: left;}
.typePos .typePos-wrapper-caption .typePos-header::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-caption .typePos-footer {float: right;}
.typePos .typePos-wrapper-caption .typePos-footer::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}

.typePos .typePos-wrapper-main {display: flex; flex-direction: column; flex: 1; overflow: hidden;}
.typePos .typePos-wrapper-main .typePos-main-header {padding: 10px 20px 2px 20px;}
.typePos .typePos-wrapper-main .typePos-main-header::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-main .typePos-main-header .typePos-header {position: relative; float: left;}
.typePos .typePos-wrapper-main .typePos-main-header .typePos-header::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-main .typePos-main-header .typePos-header .typePos-title {float: left; padding: 6px 0 7px 0; color: #222; font-size: 18px; font-family: 'NanumSquare-Regular'; line-height: 27px;}
.typePos .typePos-wrapper-main .typePos-main-header .typePos-header .typePos-caption {float: left; padding: 12px 0 9px 10px; color: #666; font-size: 13px; font-family: 'NanumSquare-Regular'; line-height: 19px;}
.typePos .typePos-wrapper-main .typePos-main-header .typePos-header .typePos-caption strong {color: #18b3c9; font-weight: normal;}
.typePos .typePos-wrapper-main .typePos-main-header .typePos-footer {float: right;}
.typePos .typePos-wrapper-main .typePos-main-header .typePos-footer::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-main .typePos-main-body {flex: 1; overflow: hidden; border-top: 1px solid #e0e0e0;}

.typePos .typePos-wrapper-footer {padding: 15px; border-top: 1px solid #bebebe;}
.typePos .typePos-wrapper-footer::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-footer .typePos-header {float: left; list-style: none; padding: 0; margin: 0;}
.typePos .typePos-wrapper-footer .typePos-button {float: right; list-style: none; padding: 0; margin: 0;}
.typePos .typePos-wrapper-footer .typePos-button::after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
.typePos .typePos-wrapper-footer .typePos-button > li {float: left; padding: 0 5px;}
</style>

<script>

import EjsGridWrapper from "@/components/common/EjsGridWrapper";
import {Aggregate, Edit, ForeignKey, Resize, Sort} from "@syncfusion/ej2-vue-grids";
import {toShortcutString} from '@/utils/KeyboardUtil';
import ErpButton from "@/components/button/ErpButton.vue";
import {getDeviceInfo} from "@/utils/device";

export default {
  name: "OrderMonitorPrtPopup",
  components: {  EjsGridWrapper,  ErpButton },
  props: {
    // salesDate: {type: Date, required: true,},
    // store: {type: Object, required: true,},
  },
  created() {
  },
  data() {
    return {
        isComfrimPrint: false,
        isBillPrinter: getDeviceInfo().posPrinterOutput,
        isKitchenPrintner: getDeviceInfo().kitchenPrinterOutput,
        gridField:{
            dataSource: [],
        },
        kitchenPaperNumber: getDeviceInfo().kitchenPaperNumber,
    };
  },
  computed: {
    dialogProps() {
      const dialogProps = {
        enableResize: true,
        header: "주문관제",
        width: 1560,
        height: 760,
        allowDragging: true,
        animationSettings: { effect: "None" },
        isModal: true,
        position: { x: "center", y: "center" },
        visible: false,
        showCloseIcon: true,
      };
      if (!dialogProps.height) {
        if (!dialogProps.cssClass) {
          dialogProps.cssClass = "dialog-non-height";
        } else {
          dialogProps.cssClass = `${dialogProps.cssClass} dialog-non-height`;
        }
      }
      return dialogProps;
    },
    initGrid() {
      return {
          columns: [
              {field: "isCheck",         headerText: "",            textAlign: 'center',   allowEditing: true,  width: 50 , visible: true, type: "boolean", editType: "booleanedit", displayAsCheckBox: true,}, // 디자인 틀려짐 editType: "booleanedit", displayAsCheckBox: true, isSelectAllColumn: true
              {field: "storeCode",       headerText: "매장명",      textAlign: 'center',   allowEditing: false, width: 120, visible: true, type: "string", isCommonCodeField: true,groupCode: "STORE_CODE",},
              {field: "slipNo",          headerText: "전표번호",    textAlign: 'center',   allowEditing: false, width: 120, visible: true, type: "string",},
              {field: "prtSno",          headerText: "주문차수",    textAlign: 'center',   allowEditing: false, width: 120, visible: false,type: "string",},
              {field: "orderId",         headerText: "주문번호",    textAlign: 'center',   allowEditing: false, width: 120, visible: true, type: "string", isPrimaryKey: true,},
              {field: "visitName",       headerText: "고객명",      textAlign: 'center',   allowEditing: false, width: 120, visible: true, type: "string",},
              {field: "lockerNo",        headerText: "락카번호",    textAlign: 'center',   allowEditing: false, width: 120, visible: true, type: "string",},
              {field: "productName",     headerText: "상품명",      textAlign: 'center',   allowEditing: false, width: 120, visible: true, type: "string",},
              {field: "saleQty",         headerText: "수량",        textAlign: 'center',   allowEditing: false, width: 120, visible: true, type: "string",},
              {field: "kitchenPrtFlag",  headerText: "주방출력여부",textAlign: 'center',   allowEditing: false, width: 100, visible: true, type: "boolean", displayAsCheckBox: true,},
              {field: "insertId",        headerText: "입력자",      textAlign: 'center',   allowEditing: false, width: 120, visible: true, type: "string",},
              {field: "insertDt",        headerText: "입력시간",    textAlign: 'center',   allowEditing: false, width: 120, visible: true, type: "string",},
              {field: "confirmFlag",     headerText: "확인",        textAlign: 'center',   allowEditing: false, width: 50 , visible: true, type: "boolean",displayAsCheckBox: true,},
              {field: "printFlag",       headerText: "출력",        textAlign: 'center',   allowEditing: false, width: 50 , visible: true, type: "boolean",displayAsCheckBox: true,},
              {field: "memoContents",    headerText: "메모",        textAlign: 'center',   allowEditing: false, width: 120, visible: false,type: "string",},

          ],
        allowFiltering: false,
        allowResizing: true,
        allowSelection: true,
        allowSorting: false,
        dataSource: this.gridField.dataSource,
        isInPopup: true,
        isNOColumnDisplay: false,
        provides: [Aggregate, ForeignKey, Resize, Sort,Edit],
        selectionSettings: { type: "Single", enableToggle: false },
        useCommonStyles: false,
      };
    },
  },
    watch: {
        isComfrimPrint() {
            this.$emit("changeData",this.isComfrimPrint);
        },
    },
  methods: {
        toShortcutString,
//region API
//endregion
//region Button
      show(orderMonitorPtrList) {
          const gridData = this.$refs.grid.getBatchCurrentViewRecords()||[];
          orderMonitorPtrList.forEach(item=>{
              item.isCheck = gridData.find(it => it.orderId == item.orderId)?gridData.find(it => it.orderId == item.orderId).isCheck:true;
          });
          this.gridField.dataSource = orderMonitorPtrList.map((data, i, array) => ({
              ...data,
              mergeFlag: (array[i - 1]?.slipNo ? array[i - 1].slipNo : "") == data.slipNo && (array[i - 1]?.prtSno ? array[i - 1].prtSno : "") == data.prtSno,
              groupPk: `${data.slipNo}${data.prtSno}`,
          }));
          this.$refs["dialog"].show();
      },
      hide() {
          this.$refs["dialog"].hide();
      },
      onDialogClose() {
          this.$emit("close");
      },
      onClickComfrim() {
          const gridData = this.$refs.grid.getBatchCurrentViewRecords();
          this.$emit("updateOrderMonitorPrt",{data:gridData,type:"CONFIRM"}, true);
      },
      onClickPrint() {
          const gridData = this.$refs.grid.getBatchCurrentViewRecords();
          this.$emit("onKitchenStatementIssue", gridData);
      },
      onCloseClick() {
          this.hide();
      },

//endregion
//region 프린터 출력 함수
//endregion
//region Grid
      onGridQueryCellInfo(args) {
          const {cell, column: {field, allowEditing}, data,} = args;
          if (allowEditing && field) {
              cell.classList.add(this.$t('className.grid.modifyArea'));
          }
          if (["isCheck", "storeCode", "slipNo", "orderId", "visitName", "lockerNo"].includes(field) && data.mergeFlag) {
              args.cell.innerText = null;
          }
      },
      onGridCellEdit(args) {
          if(args.columnName=="isCheck"){
              const rowIndex = this.$refs.grid.getRowIndexByPrimaryKey(args.rowData.orderId);
              this.$refs.grid.updateCell( rowIndex,args.columnName,!args.rowData.isCheck );
          }
      },

//endregion

  },
};
</script>
